import { render, staticRenderFns } from "./RegisterJob.vue?vue&type=template&id=bc73a4ac&"
import script from "./RegisterJob.vue?vue&type=script&lang=js&"
export * from "./RegisterJob.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports